<template >
  <div class="vx-row  flex-1">
    <vs-card class="vx-col lg:w-1/4" style="height: 75vh;overflow-y: scroll;">
      <vs-input v-model="search.ReportName" placeholder="search" class="w-full" name="search" />
      <h2 class="ml-8 mt-5 pl-12" style="color:red">{{ $t('Records') }}</h2>
      <div v-for="item in filterReports" :key="item.id" :class="item == selectedReport ? 'Active' : 'InActive'"
        class="shadow-md w-full mt-2">
        <p class="p-3" @click="ReportClick(item)">
          {{ item.name }}
        </p>
      </div>
      <h2 class="ml-8 mt-5 pl-12" style="color:red">{{ $t('Reposts') }}</h2>
      <div v-for="item in ChartReports" :key="item.id" :class="item == selectedReport ? 'Active' : 'InActive'"
        class="shadow-md w-full mt-2">
        <p class="p-3" @click="ReportClick(item)">
          {{ item.name }}
        </p>
      </div>
    </vs-card>

    <vs-card class="vx-col lg:w-3/4">
      <div class="vx-row">
        <div class="vx-col lg:w-1/4"
          v-if="selectedReport.id == 31 || selectedReport.id == 30 || selectedReport.id == 29 || selectedReport.id == 21 || selectedReport.id == 22 || selectedReport.id == 23 || selectedReport.id == 25 || selectedReport.id == 26 || selectedReport.id == 24 || selectedReport.id == 27 || selectedReport.id == 28 || selectedReport.id == 20 || selectedReport.id == 19 || selectedReport.id == 15 || selectedReport.id == 12 || selectedReport.id == 10 || selectedReport.id == 9 || selectedReport.id == 7 || selectedReport.id == 8">
          <label for="from" class="vs-input--label"> {{ $t('From') }}</label>
          <datepicker :format="format" :disabledDates="disabledDates" :placeholder="$t('From')" v-model="search.DateFrom"
            @closed="getCourseClass(selectedReport.id)" class="vx-col  w-full" name="from"></datepicker>
        </div>

        <div class="vx-col lg:w-1/4"
          v-if="selectedReport.id == 31 || selectedReport.id == 30 || selectedReport.id == 29 || selectedReport.id == 21 || selectedReport.id == 22 || selectedReport.id == 23 || selectedReport.id == 25 || selectedReport.id == 26 || selectedReport.id == 24 || selectedReport.id == 27 || selectedReport.id == 28 || selectedReport.id == 20 || selectedReport.id == 19 || selectedReport.id == 15 || selectedReport.id == 12 || selectedReport.id == 10 || selectedReport.id == 9 || selectedReport.id == 7 || selectedReport.id == 8">
          <label for="from" class="vs-input--label"> {{ $t('To') }}</label>
          <datepicker :format="format" :disabledDates="disabledDates" :placeholder="$t('To')" v-model="search.DateTo"
            @closed="getCourseClass(selectedReport.id)" class="vx-col  w-full" name="from"></datepicker>
        </div>

        <div class="vx-col lg:w-1/4" v-if="selectedReport.id == 1 || selectedReport.id == 6">
          <label for="Course" class="vs-input--label"> {{ $t('Course') }} </label>
          <v-select label="Name" class=" w-full" v-model="search.CourseID" :options="courses" autocomplete
            :reduce="Course => Course.ID" />
        </div>
        <div class="vx-col lg:w-1/4" v-if="selectedReport.id == 23 || selectedReport.id == 25 || selectedReport.id == 26">
          <label for="Course" class="vs-input--label"> {{ $t('CourseRegistrations') }}</label>
          <v-select label="Name" class=" w-full" v-model="search.CourseRegistrationID" :options="courseRegistrations"
            autocomplete :reduce="courseRegistrationID => courseRegistrationID.ID" />
        </div>
        <div class="vx-col lg:w-1/4" v-if="selectedReport.id == 24 || selectedReport.id == 27 || selectedReport.id == 28">
          <label for="Course" class="vs-input--label"> {{ $t('CourseRequests') }}</label>
          <v-select label="Name" class=" w-full" v-model="search.CourseRequestID" :options="courseRequests" autocomplete
            :reduce="courseRequestID => courseRequestID.ID" />
        </div>
        <div class="vx-col lg:w-1/4" v-if="selectedReport.id == 19 || selectedReport.id == 12">
          <label for="Course" class="vs-input--label"> {{ $t('Course') }} </label>
          <v-select label="Name" class=" w-full" v-model="search.CourseIDs" :options="courses" autocomplete
            :reduce="Course => Course.ID" multiple />
        </div>

        <div class="vx-col lg:w-1/4" v-if="selectedReport.id == 20">
          <label for="ClassRoom" class="vs-input--label"> {{ $t('ClassRoom') }}</label>
          <v-select label="Name" class=" w-full" v-model="search.ClassRoomIDs" :options="classRooms" autocomplete
            :reduce="classRoom => classRoom.ID" multiple />
        </div>

        <div class="vx-col lg:w-1/4"
          v-if="selectedReport.id == 2 || selectedReport.id == 23 || selectedReport.id == 25 || selectedReport.id == 26">
          <label for="Course" class="vs-input--label">{{ $t('AnnualPlan') }} </label>
          <v-select label="displayName" class=" w-full" v-model="search.AnnualPlanID" :options="annualPlans" autocomplete
            :reduce="annualPlan => annualPlan.ID" />
        </div>
        <div class="vx-col lg:w-1/4" v-if="selectedReport.id == 3">
          <label for="Course" class="vs-input--label"> {{ $t('Diploma') }} </label>
          <v-select label="Name" class=" w-full" v-model="search.TrackID" :options="tracks" autocomplete
            :reduce="track => track.ID" />
        </div>
        <div class="vx-col lg:w-1/4" v-if="selectedReport.id == 4">
          <label for="Course" class="vs-input--label"> {{ $t('InstructorReviews') }} </label>
          <v-select label="Title" class=" w-full" v-model="search.InstructorReviewID" :options="instructorReviews"
            autocomplete :reduce="review => review.ID" />
        </div>

        <div class="vx-col lg:w-1/4" v-if="selectedReport.id == 11 || selectedReport.id == 16">
          <label for="Instructor" class="vs-input--label"> {{ $t('Instructors') }} </label>
          <v-select label="Name" class=" w-full" v-model="search.InstructorID" :options="instructors" autocomplete
            @input="getInstuctorCourseClass" :reduce="Instructor => Instructor.ID" />
        </div>

        <div class="vx-col lg:w-1/4" v-if="selectedReport.id == 5">
          <label for="Course" class="vs-input--label"> {{ $t('InstructorReviewsAnswer') }} </label>
          <v-select label="DisplayName" class=" w-full" v-model="search.InstructorReviewAnswerID"
            :options="instructorAnswers" autocomplete :reduce="review => review.Code" />
        </div>
        <!-- <div class="vx-col lg:w-1/4" v-if="selectedReport.id == 5">
          <label for="Course" class="vs-input--label"> {{ $t('InstructorReviewsAnswer') }} </label>
          <v-select label="DisplayName" class=" w-full" v-model="search.InstructorReviewAnswerID"
            :options="instructorAnswers" autocomplete :reduce="review => review.Code" />
        </div> -->

        <div class="vx-col lg:w-1/4" v-if="false">
          <label for="Course" class="vs-input--label">{{ $t('CourseFeedback') }} </label>
          <v-select label="Name" class=" w-full" v-model="search.CourseReviewID" :options="courseReviews" autocomplete
            :reduce="review => review.ID" />
        </div>

        <div class="vx-col lg:w-1/4"
          v-if="selectedReport.id == 11 || selectedReport.id == 29 || selectedReport.id == 22 || selectedReport.id == 15 || selectedReport.id == 10 || selectedReport.id == 9 || selectedReport.id == 7 || selectedReport.id == 8 || selectedReport.id == 21">
          <label for="Course" class="vs-input--label"> {{ $t('CourseClass') }} </label>
          <v-select label="DisplayName" class=" w-full" v-model="search.CourseClassID" :options="courseClass" autocomplete
            :reduce="CourseClass => CourseClass.ID" @input="CourseClassChange" />
        </div>

        <div class="vx-col lg:w-1/4" v-if="selectedReport.id == 13 || selectedReport.id == 14">
          <label for="Course" class="vs-input--label"> {{ $t('CourseClass') }}</label>
          <v-select label="Name" class=" w-full" v-model="search.CourseClassID" :options="practicalCourseClass"
            autocomplete :reduce="CourseClass => CourseClass.ID" @input="CourseClassChange" />
        </div>

        <div class="vx-col lg:w-1/4" v-if="selectedReport.id == 7">
          <label for="Course" class="vs-input--label">{{ $t('SessionDay') }}</label>
          <v-select label="Name" class=" w-full" v-model="search.Session" :options="ClassSessions" autocomplete
            :reduce="Session => Session" />
        </div>

        <div class="vx-col lg:w-1/4"
          v-if="selectedReport.id == 22 || selectedReport.id == 17 || selectedReport.id == 15 || selectedReport.id == 8 || selectedReport.id == 13 || selectedReport.id == 14">
          <label for="Course" class="vs-input--label"> {{ $t('Trainee') }}</label>
          <v-select label="FullName" class="w-full" v-model="search.TraineeID" :options="trainees" autocomplete
            :reduce="trainee => trainee.ID" />
        </div>

        <div class="vx-col lg:w-1/4" v-if="selectedReport.id == 6">
          <label for="CourseType" class="vs-input--label"> {{ $t('CourseType') }}</label>
          <v-select label="Name" class=" w-full" v-model="search.CourseTypeID" :options="CourseTypes" autocomplete
            :reduce="CourseType => CourseType.ID" />
        </div>
        <div class="vx-col lg:w-1/4" v-if="selectedReport.id == 18">
          <label for="Customer" class="vs-input--label"> {{ $t('Organization') }}</label>
          <v-select label="FullName" class=" w-full" v-model="search.CustomerID" :options="customers" autocomplete
            :reduce="customer => customer.ID" />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button class="ml-4 mt-2" color="danger" @click="ViewReport">{{ $t('View') }}</vs-button>
          </div>
        </div>
      </div>
    </vs-card>
  </div>
</template>
<script>
import moduleCourse from "@/store/course/moduleCourse.js";
import vSelect from 'vue-select'
import moduleTrack from "@/store/track/moduleTrack.js";
import moduleAnnualPlan from "@/store/annualPlan/moduleAnnualPlan.js";
import moduleInstructorReview from "@/store/customerReview/instructorReview/moduleInstructorReview.js";
import moduleAssessmentResult from "@/store/customerReview/assessmentResult/moduleAssessmentResult.js";
import moduleCourseReview from "@/store/customerReview/courseReview/moduleCourseReview.js";
import moduleCourseClass from "@/store/courseClass/moduleCourseClass.js";
import Datepicker from 'vuejs-datepicker';
import moduleTrainee from "@/store/user/trainee/moduleTrainee.js";
import moduleCourseType from "@/store/settings/courseType/moduleCourseType.js";
import moduleInstructor from "@/store/instructor/moduleInstructor.js";
import moduleCustomer from "@/store/user/customer/moduleCustomer.js";
import moduleClassRoom from "@/store/settings/classRoom/moduleClassRoom.js";
import moduleCourseRegistration from "@/store/courseRegistration/moduleCourseRegistration.js";
import moduleCourseRequest from "@/store/courseRequest/moduleCourseRequest.js";

export default {
  components: {
    vSelect,
    Datepicker
  },
  data() {
    return {
      disabledDates: {},
      format: "dd-MM-yyyy",
      search: {},
      selectedReport: { ReportName: '', },

      ReportList: [
        // {name:"Course Profile",id:1,selected:true},
        // {name:"Course Plane Detail",id:2,selected:false},
        // {name:"Diploma Profile",id:3,selected:false},
        // {name:"Instructor Assessment",id:4,selected:false},
        { name: this.$t('InstructorAssessmentResult'), id: 5, selected: false },
        { name: this.$t('FeedbackQuestionnaire'), id: 6, selected: false },
        { name: this.$t('FeedbackQuestionnaireAnswer'), id: 22, selected: false },
        { name: this.$t('TraineeAttendanceSheet'), id: 7, selected: false },
        { name: this.$t('DailyAttendanceSheet'), id: 9, selected: false },
        { name: this.$t('InstructorAttendanceSheet'), id: 10, selected: false },
        { name: this.$t('AuthorizationOfInstruction'), id: 11, selected: false },
        { name: this.$t('TrainingCourseStatistic'), id: 12, selected: false },
        { name: this.$t('CoursePractical'), id: 13, selected: false },
        { name: this.$t('PracticalEvaluation'), id: 14, selected: false },
        { name: this.$t('FinalEvaluation'), id: 15, selected: false },
        // {name:"Instructor Profile",id:16,selected:false},
        // {name:"Trainee Profile",id:17,selected:false},
        // {name:"Organization Profile",id:18,selected:false},
        // {name:"Annual Plan",id:19,selected:false},
        { name: this.$t('ClassRoomSchedule'), id: 20, selected: false },
        { name: this.$t('Certificate'), id: 8, selected: false },
        { name: this.$t('CourseClassEvaluationMean'), id: 21, selected: false },
        { name: this.$t('CourseRegistrationInvoice'), id: 23, selected: false },
        { name: this.$t('CourseRequestInvoice'), id: 24, selected: false },
        { name: this.$t('RegistrationInvitationLetter'), id: 25, selected: false },
        { name: this.$t('RegistrationPlacementLetter'), id: 26, selected: false },
        { name: this.$t('RequestInvitationLetter'), id: 27, selected: false },
        { name: this.$t('RequestPlacementLetter'), id: 28, selected: false },
        { name: this.$t('TrainingOrder'), id: 29, selected: false },
        { name: this.$t('AnnualPlan'), id: 31, selected: false },
        { name: this.$t('TraineeEmails'), id: 32, selected: false },


      ],
      ChartReports: [
        { name: this.$t('CourseClassStatisticCharts'), id: 30, selected: false },
      ]
    }
  },
  methods: {
    getInstuctorCourseClass() {
      debugger
      if (this.selectedReport.id == 11) {
        this.$vs.loading();

        this.$store.dispatch("courseClassList/SearchCourseClass", { InstructorID: this.search.InstructorID }).then(() => {
          this.$vs.loading.close();

        })
      }
    },
    getCourseClass(selectedReportid) {
      if (selectedReportid == 23 || selectedReportid == 25 || selectedReportid == 26) {
        this.$vs.loading();
        this.$store.dispatch("courseRegistrationList/searchCourseRegistration", { StartDate: this.search.DateFrom, EndDate: this.search.DateTo }).then(() => {
          this.$vs.loading.close();
        })


      }
      else if (selectedReportid == 24 || selectedReportid == 27 || selectedReportid == 28) {
        this.$vs.loading();

        this.$store.dispatch("courseRequestList/searchCourseRequest", { StartDate: this.search.DateFrom, EndDate: this.search.DateTo }).then(() => {
          this.$vs.loading.close();
        });
      }

      else {
        this.$store.dispatch("courseClassList/SearchCourseClass", { StartDate: this.search.DateFrom, EndDate: this.search.DateTo })

      }

      this.$store.dispatch("annualPlanList/SearchAnnualPlan", {
        StartDate: this.search.DateFrom,
        EndDate: this.search.DateTo
      })
    },
    onlyUnique(value, index, self) {
      return self.findIndex((p) => p.Name == value.Name) === index;
    },
    CourseClassChange() {
      debugger
      this.$store.dispatch("courseClassList/GetSessionByCourseClassID", { courseClassID: this.search.CourseClassID });
      if (this.selectedReport.id == 8) {
        this.$store.commit("traineeList/SET_Trainees", []);
        this.$store.dispatch("traineeList/GetPassedTraineeByCourseClassID", this.search.CourseClassID);
      }
      else
        this.$store.dispatch("traineeList/GetTraineeByCourseClassID", this.search.CourseClassID);

    },
    ReportClick(item) {
      this.search = {};
      this.ReportList.forEach(function (obj) { obj.selected = false; });
      item.selected = !item.selected;
      this.selectedReport = item;
      if (item.id == 8) {
        this.disabledDates = {
          to: new Date(new Date().getFullYear() - 5, new Date().getMonth(), new Date().getDate()), // Disable all dates up to specific date
          from: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()), // Disable all dates after specific date
        }
        this.$store.dispatch("courseClassList/SearchCourseClass", { EndDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()) })
      }

      else {
        this.disabledDates = {};
      }
    },
    formatJsDate(dateToFormat) {
      return dateToFormat.getFullYear() + "-" + (dateToFormat.getMonth() + 1) + "-" + dateToFormat.getDate();
    },
    ViewReport() {
      if (this.selectedReport.id == 1) {
        window.open('#/Report/CourseDetail/' + this.search.CourseID, '_blank');
      }
      else if (this.selectedReport.id == 2) {
        window.open('#/Report/UpcomingCourseDetail/' + this.search.AnnualPlanID, '_blank');
      }
      else if (this.selectedReport.id == 3) {
        window.open('#/Report/DiplomaDetail/' + this.search.TrackID, '_blank');
      }
      else if (this.selectedReport.id == 4) {
        window.open('#/Report/InstructorAssessment/' + this.search.InstructorReviewID, '_blank');
      }
      else if (this.selectedReport.id == 5) {
        window.open('#/Report/InstructorAssessmentAnswer/' + this.search.InstructorReviewAnswerID, '_blank');
      }
      else if (this.selectedReport.id == 6) {
        window.open('#/Report/CourseFeedBack/' + this.search.CourseID + '/' + this.search.CourseTypeID, '_blank');
      }
      else if (this.selectedReport.id == 7) {
        window.open('#/Report/TraineeAttendanceSheet/' + this.search.CourseClassID + '/' + this.search.Session.Name, '_blank');
      }
      else if (this.selectedReport.id == 8) {
        //var trainee = this.trainees.find((obj) =>  obj.ID == this.search.TraineeID );

        // if(trainee.IsPass)
        //      window.open('#/Report/Certificate/'+this.search.CourseClassID+"/"+this.search.TraineeID, '_blank');
        // else
        window.open('#/Report/AttendeCertificate/' + this.search.CourseClassID + "/" + this.search.TraineeID, '_blank');
      }
      else if (this.selectedReport.id == 9) {
        window.open('#/Report/DailyAttendanceSheet/' + this.search.CourseClassID, '_blank');
      }
      else if (this.selectedReport.id == 10) {
        window.open('#/Report/InstructorLogin/' + this.search.CourseClassID, '_blank');
      }
      else if (this.selectedReport.id == 11) {
        window.open('#/Report/AuthorizationOfInstruction/' + this.search.InstructorID + "/" + this.search.CourseClassID, '_blank');
      }
      else if (this.selectedReport.id == 12) {
        var courses = '0'
        if (this.search.CourseIDs && this.search.CourseIDs.length > 0) {
          courses = this.search.CourseIDs.join();
        }
        window.open('#/Report/TraininingCourseStatistic/' + courses + "/" + (this.search.DateFrom != undefined ? this.formatJsDate(this.search.DateFrom) : '0') + "/" + (this.search.DateTo != undefined ? this.formatJsDate(this.search.DateTo) : '0'), '_blank');
      }
      else if (this.selectedReport.id == 13) {
        window.open('#/Report/CoursePractical/' + this.search.CourseClassID + "/" + this.search.TraineeID, '_blank');
      }
      else if (this.selectedReport.id == 14) {
        window.open('#/Report/GeneralPractical/' + this.search.CourseClassID + "/" + this.search.TraineeID, '_blank');
      }
      else if (this.selectedReport.id == 15) {
        window.open('#/Report/FinalEvaluation/' + this.search.CourseClassID + "/" + this.search.TraineeID, '_blank');
      }
      else if (this.selectedReport.id == 16) {
        window.open('#/Report/InstructorProfile/' + this.search.InstructorID, '_blank');
      }
      else if (this.selectedReport.id == 17) {
        window.open('#/Report/TraineeProfile/' + this.search.TraineeID, '_blank');
      }
      else if (this.selectedReport.id == 18) {
        window.open('#/Report/OrganizationProfile/' + this.search.CustomerID, '_blank');
      }
      else if (this.selectedReport.id == 19) {
        courses = '0'
        if (this.search.CourseIDs && this.search.CourseIDs.length > 0) {
          courses = this.search.CourseIDs.join();
        }
        window.open('#/Report/AnnualPlanGridView/' + courses + "/" + (this.search.DateFrom != undefined ? this.formatJsDate(this.search.DateFrom) : '0') + "/" + (this.search.DateTo != undefined ? this.formatJsDate(this.search.DateTo) : '0'), '_blank');
      }
      else if (this.selectedReport.id == 20) {
        var ClassRoomIDs = '0'
        if (this.search.ClassRoomIDs && this.search.ClassRoomIDs.length > 0) {
          ClassRoomIDs = this.search.ClassRoomIDs.join();
        }
        window.open('#/Report/ClassRoomSchedule/' + ClassRoomIDs + "/" + (this.search.DateFrom != undefined ? this.formatJsDate(this.search.DateFrom) : '0') + "/" + (this.search.DateTo != undefined ? this.formatJsDate(this.search.DateTo) : '0'), '_blank');
      }

      else if (this.selectedReport.id == 21) {
        debugger
        var CourseClassID = 0
        if (this.search.CourseClassID) {
          CourseClassID = this.search.CourseClassID;
        }
        window.open('#/Report/CourseClassEvaluationMeanStatistic/' + CourseClassID, '_blank');
      }

      else if (this.selectedReport.id == 22) {
        window.open('#/Report/CourseFeedBackAnswer/' + this.search.CourseClassID + '/' + this.search.TraineeID, '_blank');
      }

      else if (this.selectedReport.id == 23) {
        window.open('#/Report/CourseRegistrationInvoice/' + this.search.CourseRegistrationID + "/" + this.search.AnnualPlanID, '_blank');
      }

      else if (this.selectedReport.id == 24) {
        window.open('#/Report/CourseRequestInvoice/' + this.search.CourseRequestID, '_blank');
      }

      else if (this.selectedReport.id == 25) {
        window.open('#/Report/RegistrationInvitation/' + this.search.CourseRegistrationID + "/" + this.search.AnnualPlanID, '_blank');
      }

      else if (this.selectedReport.id == 26) {
        window.open('#/Report/RegistrationPlacementLetterReport/' + this.search.CourseRegistrationID + "/" + this.search.AnnualPlanID, '_blank');
      }

      else if (this.selectedReport.id == 27) {
        window.open('#/Report/CourseRequestInvitation/' + this.search.CourseRequestID, '_blank');
      }

      else if (this.selectedReport.id == 28) {
        window.open('#/Report/CourseRequestPlacement/' + this.search.CourseRequestID, '_blank');
      }

      else if (this.selectedReport.id == 29) {
        window.open('#/Report/TrainingOrder/' + this.search.CourseClassID, '_blank');
      }
      else if (this.selectedReport.id == 30) {
        window.open('#/Report/TraininingCourseStatisticChart/' + (this.search.DateFrom != undefined ? this.formatJsDate(this.search.DateFrom) : undefined) + "/" + (this.search.DateFrom != undefined ? this.formatJsDate(this.search.DateTo) : undefined), '_blank');
      }
      else if (this.selectedReport.id == 31) {
        window.open('#/Report/AnnualPlan/' + (this.search.DateFrom != undefined ? this.formatJsDate(this.search.DateFrom) : undefined) + "/" + (this.search.DateFrom != undefined ? this.formatJsDate(this.search.DateTo) : undefined), '_blank');
      }
      else if (this.selectedReport.id == 32) {
        window.open('#/Report/TraineeEmails/', '_blank');
      }
    }
  },
  computed: {
    courseRequests() {

      return this.$store.state.courseRequestList.courseRequests;
    },
    courseRegistrations() {

      return this.$store.state.courseRegistrationList.courseRegistrations;
    },
    classRooms() {
      return this.$store.state.classRoomList.classRooms;
    },
    customers() {
      return this.$store.state.customerList.customers;
    },
    instructors() {
      return this.$store.state.instructorList.instructors;
    },
    CourseTypes() {
      return this.$store.state.courseTypeList.courseTypes;
    },
    ClassSessions() {
      this.$store.state.courseClassList.courseClassSessions.forEach(function (item) { item.Name = item.Start.split('T')[0] })
      var temp = this.$store.state.courseClassList.courseClassSessions.filter(this.onlyUnique)
      return temp;
    },
    trainees() {
      return this.$store.state.traineeList.trainees;
    },
    courses() {
      return this.$store.state.courseList.courses;
    },
    tracks() {
      return this.$store.state.trackList.tracks;
    },
    annualPlans() {
      return this.$store.state.annualPlanList.annualPlanList;
    },
    instructorReviews() {
      return this.$store.state.InstructorReviewList.InstructorReviews;
    },
    instructorAnswers() {
      return this.$store.state.AssessmentResultList.assessmentResults;
    },
    courseReviews() {
      this.$store.state.CourseReviewList.CourseReviews.forEach(function (item) { item.Name = item.CourseType.Name })
      return this.$store.state.CourseReviewList.CourseReviews;
    },
    courseClass() {
      this.$store.state.courseClassList.courseClass.forEach(function (item) { item.Name = item.Course.Name + '(' + item.ClassNo + ')' })
      return this.$store.state.courseClassList.courseClass;
    },
    practicalCourseClass() {
      this.$store.state.courseClassList.practicalCourseClass.forEach(function (item) { item.Name = item.Course.Name + '(' + item.ClassNo + ')' })
      return this.$store.state.courseClassList.practicalCourseClass;
    },
    filterReports() {
      if (this.search.ReportName) {
        var vm = this;
        return this.ReportList.filter(function (obj) {
          return obj.name.toLowerCase().indexOf(vm.search.ReportName.toLowerCase()) > -1
        });
      }
      else
        return this.ReportList
    },
  },
  created() {
    if (!moduleCourseRequest.isRegistered) {
      this.$store.registerModule("courseRequestList", moduleCourseRequest);
      moduleCourseRequest.isRegistered = true;
    }

    this.selectedReport = this.ReportList[0];
    if (!moduleCourseRegistration.isRegistered) {
      this.$store.registerModule("courseRegistrationList", moduleCourseRegistration);
      moduleCourseRegistration.isRegistered = true;
    }

    if (!moduleCourse.isRegistered) {
      this.$store.registerModule("courseList", moduleCourse);
      moduleCourse.isRegistered = true;
    }
    if (!moduleTrack.isRegistered) {
      this.$store.registerModule("trackList", moduleTrack);
      moduleTrack.isRegistered = true;
    }
    if (!moduleAnnualPlan.isRegistered) {
      this.$store.registerModule("annualPlanList", moduleAnnualPlan);
      moduleAnnualPlan.isRegistered = true;
    }
    if (!moduleInstructorReview.isRegistered) {
      this.$store.registerModule("InstructorReviewList", moduleInstructorReview);
      moduleInstructorReview.isRegistered = true;
    }
    if (!moduleAssessmentResult.isRegistered) {
      this.$store.registerModule("AssessmentResultList", moduleAssessmentResult);
      moduleAssessmentResult.isRegistered = true;
    }
    if (!moduleCourseReview.isRegistered) {
      this.$store.registerModule("CourseReviewList", moduleCourseReview);
      moduleCourseReview.isRegistered = true;
    }
    if (!moduleCourseClass.isRegistered) {
      this.$store.registerModule("courseClassList", moduleCourseClass);
      moduleCourseClass.isRegistered = true;
    }
    if (!moduleTrainee.isRegistered) {
      this.$store.registerModule("traineeList", moduleTrainee);
      moduleTrainee.isRegistered = true;
    }
    if (!moduleCourseType.isRegistered) {
      this.$store.registerModule("courseTypeList", moduleCourseType);
      moduleCourseType.isRegistered = true;
    }
    if (!moduleInstructor.isRegistered) {
      this.$store.registerModule("instructorList", moduleInstructor);
      moduleInstructor.isRegistered = true;
    }
    if (!moduleCustomer.isRegistered) {
      this.$store.registerModule("customerList", moduleCustomer);
      moduleCustomer.isRegistered = true;
    }
    if (!moduleClassRoom.isRegistered) {
      this.$store.registerModule("classRoomList", moduleClassRoom);
      moduleClassRoom.isRegistered = true;
    }
    this.$store.dispatch("classRoomList/fetchDataListItems");
    this.$store.dispatch("customerList/fetchDataListItems");
    this.$store.dispatch("traineeList/fetchDataListItems");
    this.$store.dispatch("instructorList/fetchDataListItems");
    this.$store.dispatch("courseClassList/fetchDataListItems");
    this.$store.dispatch("courseTypeList/fetchDataListItems");
    this.$store.dispatch("CourseReviewList/fetchDataListItems")
    this.$store.dispatch("AssessmentResultList/fetchAssessmentResults", {});
    this.$store.dispatch("InstructorReviewList/fetchDataListItems");
    this.$store.dispatch("annualPlanList/SearchAnnualPlan", {
      StartDate: new Date(new Date().getFullYear(), 1, 1),
      EndDate: new Date(new Date().getFullYear() + 2, 1, 1)
    })
    this.$store.dispatch("courseList/fetchDataListItems");
    this.$store.dispatch("trackList/fetchDataListItems");
    this.$store.dispatch("courseClassList/GetPracticalCourseClasses")
  }
}
</script>
<style>
.Active {
  background: #CC1814;
  color: white;
  padding: 0px;
  border-radius: 12px;
}

.InActive {
  color: #CC1814;
  border: 1px solid #CC1814;
  background: white;
  padding: 0px;
  border-radius: 12px;
}
</style>
